import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React from 'react';
import {
  VertButton,
  VertContainer,
  Button,
  Col,
  Row,
  VertTypography,
} from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

export const SpotButtons = ({ spot, isLoading, callModal }) => {
  const navigate = useNavigate();
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const currentParticipantId = userProfile['custom:participant_id'];

  const isAccessParticipantToEdit =
    currentParticipantId == String(spot.participantId) && spot.sendToOperation;

  return (
    <VertContainer className="container-button-view-redemption">
      <Row justify="center" gutter={[16, 16]} verticalSpacing="regular">
        {spot !== null &&
          spot.redemptionStatusId !== 5 &&
          spot.redemptionStatusId !== 6 && (
            <Col xs={24} sm={12} md={8} lg={6}>
              <Button
                className="button-view-redemption-danger"
                loading={isLoading}
                onClick={() => callModal('cancel')}
                danger
              >
                Cancelar
              </Button>
            </Col>
          )}

        {spot !== null && spot.redemptionStatusId === 4 && spot.type === 3 && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <VertButton
              type="highlight"
              className="button-view-redemption"
              loading={isLoading}
              onClick={() => callModal('approve')}
            >
              Aprovar Solicitação
            </VertButton>
          </Col>
        )}
      </Row>
      {(spot.type === 1 || spot.type === 2) &&
        !(spot.redemptionStatusId === 5 || spot.redemptionStatusId === 6) &&
        isAccessParticipantToEdit && (
          <Row
            justify="center"
            className="row-button"
            verticalSpacing="regular"
            gutter={[16, 16]}
          >
            <Col xs={24} sm={12} md={8} lg={6}>
              <VertTypography.Paragraph
                className="title-terms-aprovation"
                style={{
                  marginBottom: '8px',
                }}
              >
                Gostaria de editar essa solicitação?
              </VertTypography.Paragraph>
              <VertButton
                type="default"
                loading={isLoading}
                onClick={() => {
                  navigate(`/edit-redemption/${spot.id}`);
                }}
                className="button-view-redemption-danger"
              >
                Editar Solicitação
              </VertButton>
            </Col>
          </Row>
        )}

      <Row
        justify="center"
        className="row-button"
        verticalSpacing="regular"
        gutter={[16, 16]}
      >
        <Col xs={24} sm={12} md={8} lg={6}>
          <VertButton
            type="default"
            className="button-view-redemption"
            loading={isLoading}
            onClick={() => navigate('/list-redemptions')}
          >
            Ver Solicitações
          </VertButton>
        </Col>
      </Row>
    </VertContainer>
  );
};

SpotButtons.propTypes = {
  spot: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  callModal: PropTypes.func,
};
